import styled from '@emotion/styled';
import { InpockView } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

export const MarketView = styled(InpockView)`
  padding-bottom: 0 !important;
  position: relative;
`;

export const ToTopButton = styled.div`
  position: fixed;
  bottom: 72px;
  right: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  right: calc((100vw - 600px) / 2 + 70px);
  z-index: 10;
  opacity: 1;
  visibility: visible;
  transition:
    visibility 0.3s,
    opacity 0.3s;

  @media (max-width: 600px) {
    right: 12px;
  }

  &.hide {
    opacity: 0;
    visibility: hidden;
    transition:
      visibility 0.3s,
      opacity 0.3s;
  }
`;

export const StyledSection = styled.div`
  padding: 20px 12px;

  .section-title {
    margin-bottom: 20px;
  }
`;

export const MarketFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 12px 40px;
  background-color: ${colors.gray100};

  .extra-info {
    margin-top: 20px;
    background-color: ${colors.gray200};
    padding: 12px;
  }
`;
